module.exports = __webpack_public_path__ + "static/img/1.a852c8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/logos/1.svg
// module id = 696
// module chunks = 1